import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, setApiKeyToObject, toPathString } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ApplicationPathTagPublicControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary 지원경로 조회 API
     * @param {ApplicationPathTagPublicControllerApiGetApplicationPathTagsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApplicationPathTagsPublic: ({ customerIdHash }, options = {}) => {
      assertParamExists("getApplicationPathTagsPublic", "customerIdHash", customerIdHash);
      const localVarPath = "/api-public/v2/recruiting/customers/{customerIdHash}/application-path-tags".replace("{".concat("customerIdHash", "}"), encodeURIComponent(String(customerIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setApiKeyToObject(localVarHeaderParameter, "WS_AID", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return __spreadProps(__spreadValues({}, localVarRequestOptions), {
        identifier: "getApplicationPathTagsPublic",
        url: toPathString(localVarUrlObj)
      });
    }
  };
};
const ApplicationPathTagPublicControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = ApplicationPathTagPublicControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary 지원경로 조회 API
     * @param {ApplicationPathTagPublicControllerApiGetApplicationPathTagsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApplicationPathTagsPublic(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getApplicationPathTagsPublic(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const ApplicationPathTagPublicControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = ApplicationPathTagPublicControllerApiFp(configuration);
  return {
    /**
     * 
     * @summary 지원경로 조회 API
     * @param {ApplicationPathTagPublicControllerApiGetApplicationPathTagsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApplicationPathTagsPublic(requestParameters, options) {
      return localVarFp.getApplicationPathTagsPublic(requestParameters, options)(axios, basePath);
    }
  };
};
class ApplicationPathTagPublicControllerApi extends BaseAPI {
  /**
   * 
   * @summary 지원경로 조회 API
   * @param {ApplicationPathTagPublicControllerApiGetApplicationPathTagsPublicRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationPathTagPublicControllerApi
   */
  getApplicationPathTagsPublic(requestParameters, options) {
    return ApplicationPathTagPublicControllerApiFp(this.configuration).getApplicationPathTagsPublic(requestParameters, options)(this.axios, this.basePath);
  }
}
const getApplicationPathTagsPublicRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: ApplicationPathTagPublicControllerApiAxiosParamCreator().getApplicationPathTagsPublic,
  requestFn: ApplicationPathTagPublicControllerApiFp().getApplicationPathTagsPublic
});

export { ApplicationPathTagPublicControllerApi, ApplicationPathTagPublicControllerApiAxiosParamCreator, ApplicationPathTagPublicControllerApiFactory, ApplicationPathTagPublicControllerApiFp, getApplicationPathTagsPublicRemote };
//# sourceMappingURL=application-path-tag-public-controller-api.mjs.map
